import { getInjection } from '@/di/inversify.config';
import { Result } from '@/entities/Result';
import { CountriesResponse } from '@/infrastructure/network/dto/CountryDto';

export const getCountriesUseCase = async (): Promise<Result<CountriesResponse>> => {
	const countriesRepository = getInjection('ICountriesRepository');
	return countriesRepository.getCountries();
};
